import script from "./MCPConnections.vue?vue&type=script&setup=true&lang=js"
export * from "./MCPConnections.vue?vue&type=script&setup=true&lang=js"

import "./MCPConnections.vue?vue&type=style&index=0&id=6e1b577a&lang=css"

const __exports__ = script;

export default __exports__